module.exports = __webpack_public_path__ + "static/img/qm03-card-bg.fcffe587.png";